import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { SupabaseProvider } from './contexts/SupabaseContext';
import { AdminProvider } from './contexts/AdminContext';
import Navbar from './components/Navbar';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import EmailVerificationPage from './pages/EmailVerificationPage';
import ResendVerificationPage from './pages/ResendVerificationPage';
import Dashboard from './pages/Dashboard';
import CampaignDetails from './pages/CampaignDetails';
import CreateCampaign from './pages/CreateCampaign';
import EditCampaign from './pages/EditCampaign';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminBroadcastPage from './pages/AdminBroadcastPage';
import AdminLogsPage from './pages/AdminLogsPage';
import './App.css';

function App() {
  return (
    <SupabaseProvider>
      <AuthProvider>
        <AdminProvider>
          <Router>
            <div className="min-h-screen bg-gray-50">
              <Navbar />
              <main>
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/signup" element={<SignupPage />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  <Route path="/verify-email" element={<EmailVerificationPage />} />
                  <Route path="/resend-verification" element={<ResendVerificationPage />} />
                  
                  <Route
                    path="/dashboard"
                    element={
                      <ProtectedRoute>
                        <Dashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/campaigns/:id"
                    element={
                      <ProtectedRoute>
                        <CampaignDetails />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/campaigns/create"
                    element={
                      <ProtectedRoute>
                        <CreateCampaign />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/campaigns/:id/edit"
                    element={
                      <ProtectedRoute>
                        <EditCampaign />
                      </ProtectedRoute>
                    }
                  />

                  {/* Admin Routes */}
                  <Route
                    path="/admin"
                    element={
                      <AdminProtectedRoute>
                        <AdminDashboardPage />
                      </AdminProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/users"
                    element={
                      <AdminProtectedRoute>
                        <AdminUsersPage />
                      </AdminProtectedRoute>
                    }
                  />
                   <Route
                    path="/admin/broadcast"
                    element={
                      <AdminProtectedRoute>
                        <AdminBroadcastPage />
                      </AdminProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/logs"
                    element={
                      <AdminProtectedRoute>
                        <AdminLogsPage />
                      </AdminProtectedRoute>
                    }
                  />
                </Routes>
              </main>
              <Toaster
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                }}
              />
            </div>
          </Router>
        </AdminProvider>
      </AuthProvider>
    </SupabaseProvider>
  );
}

export default App;